"use client";

import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "./ui/dialog";
import { Button } from "./ui/button";
import {
  ArrowRight,
  CircleDollarSign,
  Loader2,
  MoveDown,
  MoveUp,
  Trash2,
} from "lucide-react";
import CurrencyFormatter from "../utils/currencyFormatter";

const AccountDeleteBlock = ({
  open,
  setOpen,
  onDelete,
  onFunds,
  assetBalances,
  subAccountName,
  activities,
  loading,
  port,
}) => {
  const formatter = new CurrencyFormatter();
  console.log("activities", activities);
  const cryptoAssets = assetBalances?.crypto || {};
  const fiatAssets = assetBalances?.fiat || {};
  const hasCrypto = Object.values(cryptoAssets).some(
    (asset) => asset?.availableAmount > 0
  );

  const hasFiat = Object.values(fiatAssets).some(
    (asset) => asset?.availableAmount > 0
  );

  const hasAssets = hasFiat || hasCrypto;
  const handleFunds = () => {
    onFunds?.();
  };
  const handleTransferAndDelete = () => {
    onDelete?.();
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-xl p-6 rounded-lg shadow-lg">
        <DialogHeader>
          <DialogTitle className="text-[24px] text-[#FF4D4D] font-semibold mt-5 mb-3">
            Review Before Deleting
          </DialogTitle>
        </DialogHeader>

        <div className="mb-4 text-[14px] text-[#6D6584]">
          You cannot delete this account until all pending activities are
          resolved.
        </div>

        <div className="space-y-4 text-sm">
          {activities?.hasActiveInvestments && (
            <div className="p-4 rounded border border-rose-300">
              <div className="font-medium text-blue-800 mb-1">
                Active Investments
              </div>
              <p className="text-blue-900">
                {activities.activeInvestments.length} investment(s) are still
                active.
              </p>
              <ul className="mt-2 list-disc list-inside text-blue-900">
                {activities.activeInvestments.map((inv) => (
                  <div
                    key={inv._id}
                    className="flex items-center justify-between"
                  >
                    <div className="flex items-center gap-3">
                      <div>
                        <div className="font-semibold ">
                          {inv?.productId?.name}
                          <span class="bg-gray-100 ml-3 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm dark:bg-gray-700 dark:text-gray-300">
                            {"Invest"}
                          </span>
                        </div>
                        <div className="text-gray-500 text-sm">
                          {inv?.productId?.roi?.$numberDecimal}%
                        </div>
                      </div>
                      <div className="ml-5">
                        <div className="font-semibold">
                          {" "}
                          {formatter.format(
                            inv?.balance,
                            inv?.productId?.assetId?.asset?.toUpperCase()
                          )}
                        </div>

                        <div className="text-gray-500">
                          {" "}
                          {formatter.format(
                            inv?.productId?.value?.$numberDecimal,
                            inv?.productId?.assetId?.asset?.toUpperCase()
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-5 items-center text-right">
                      <div>
                        {inv?.productId?.status && (
                          <div className="flex items-center gap-2 bg-purple-50 px-3 py-1 rounded-full">
                            <div
                              className={`w-2 h-2 rounded-full bg-green-500`}
                            />
                            <span className={`text-sm text-green-500`}>
                              {inv?.productId?.status &&
                                inv?.productId?.status.charAt(0).toUpperCase() +
                                  inv?.productId?.status.slice(1).toLowerCase()}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </ul>
            </div>
          )}
          {activities?.hasPendingOrders && (
            <div className="p-4 rounded border border-rose-300">
              <div className="font-medium text-yellow-800 mb-1">
                Pending Orders
              </div>
              <p className="text-yellow-900">
                {activities.pendingOrders.length} order(s) must be{" "}
                <strong>completed</strong> or <strong>cancelled</strong> before
                proceeding.
              </p>
              {/* Optional: List each pending order */}
              <ul className="mt-2 list-disc list-inside text-yellow-900">
                {activities.pendingOrders.map((order) => (
                  <div
                    key={order._id}
                    className="flex items-center justify-between"
                  >
                    <div className="flex items-center gap-3">
                      <div>
                        <div className="font-semibold ">
                          {order.incomingAsset.toUpperCase()}
                          <span class="bg-gray-100 ml-3 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm dark:bg-gray-700 dark:text-gray-300">
                            {order.type.toUpperCase()}
                          </span>
                        </div>
                        <div className="text-gray-500 text-sm">
                          {order?.currencyPair?.toUpperCase()}
                        </div>
                      </div>
                      <div className="ml-5">
                        <div className="font-semibold">
                          {" "}
                          {formatter.format(
                            order?.incomingAmount?.$numberDecimal,
                            order?.incomingAsset?.toUpperCase()
                          )}
                        </div>

                        {order.orderType && (
                          <div className="text-gray-500">
                            {" "}
                            {formatter.format(
                              order?.targetPrice?.$numberDecimal,
                              order?.outgoingAsset?.toUpperCase()
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex gap-5 items-center text-right">
                      <div>
                        {order.status && (
                          <div className="flex items-center gap-2 bg-purple-50 px-3 py-1 rounded-full">
                            <div
                              className={`w-2 h-2 rounded-full ${
                                order.status === "completed"
                                  ? "bg-green-500"
                                  : order.status === "pending"
                                    ? "bg-yellow-500"
                                    : "bg-red-500"
                              }`}
                            />
                            <span
                              className={`text-sm ${
                                order.status === "completed"
                                  ? "text-green-500"
                                  : order.status === "pending"
                                    ? "text-yellow-500"
                                    : "text-red-500"
                              }`}
                            >
                              {order.status &&
                                order.status.charAt(0).toUpperCase() +
                                  order.status.slice(1).toLowerCase()}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </ul>
            </div>
          )}

          {activities?.hasPendingSettlements && (
            <div className="p-4 rounded border border-rose-300">
              <div className="font-medium text-pink-800 mb-1">
                Pending Settlements
              </div>
              <p className="text-pink-900">
                {activities?.pendingSettlements?.length} settlement(s) are still
                processing.
              </p>
              <ul className="mt-2 list-disc list-inside text-pink-900">
                {activities?.pendingSettlements?.map((settlement) => (
                  <div
                    key={settlement._id}
                    className="flex items-center justify-between"
                  >
                    <div className="flex items-center gap-3">
                      <div>
                        <div className="font-semibold ">
                          {settlement?.incomingAsset?.toUpperCase()}
                          <span class="bg-gray-100 ml-3 text-gray-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm dark:bg-gray-700 dark:text-gray-300">
                            Post Trade
                          </span>
                        </div>
                        <div className="text-gray-500 text-sm">
                          {settlement?.incomingAsset?.toUpperCase()}
                          {"-"}
                          {settlement?.outgoingAsset?.toUpperCase()}
                        </div>
                      </div>
                      <div className="ml-5">
                        <div className="font-semibold">
                          {" "}
                          {formatter.format(
                            settlement?.awaitingFulfillment?.$numberDecimal,
                            settlement?.incomingAsset?.toUpperCase()
                          )}
                        </div>

                        <div className="text-gray-500">
                          {" "}
                          {formatter.format(
                            settlement?.awaitingSettlement?.$numberDecimal,
                            settlement?.outgoingAsset?.toUpperCase()
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-5 items-center text-right">
                      <div>
                        {settlement.status && (
                          <div className="flex items-center gap-2 bg-purple-50 px-3 py-1 rounded-full">
                            <div
                              className={`w-2 h-2 rounded-full ${
                                settlement.status === "completed"
                                  ? "bg-green-500"
                                  : settlement.status === "Pending"
                                    ? "bg-yellow-500"
                                    : "bg-red-500"
                              }`}
                            />
                            <span
                              className={`text-sm ${
                                settlement.status === "completed"
                                  ? "text-green-500"
                                  : settlement.status === "Pending"
                                    ? "text-yellow-500"
                                    : "text-red-500"
                              }`}
                            >
                              {settlement.status &&
                                settlement.status.charAt(0).toUpperCase() +
                                  settlement.status.slice(1).toLowerCase()}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </ul>
            </div>
          )}

          {!activities?.hasPendingOrders &&
            !activities?.hasActiveInvestments &&
            !activities?.hasPendingSettlements && (
              <div className="text-green-700 bg-green-50 p-4 rounded border border-green-200">
                ✅ No active activity found — you can proceed to deletion.
              </div>
            )}
        </div>

        <div className="flex items-center justify-center">
          <div className="pr-2">
            <DialogClose className="w-full">
              <Button className="text-sm font-semibold text-white rounded-full bg-gradient-to-tr from-red-500 to-purple-500 hover:opacity-90 w-full py-5 px-16">
                Go back
              </Button>
            </DialogClose>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AccountDeleteBlock;
